export default __webpack_public_path__ + "static/media/Icons_Download_File_Regular.d3c50213.svg";